import { defineComponent, SetupContext } from '@vue/composition-api';
import HttpStatus from 'http-status-codes';             // HTTPステータスコード取得用
import vueRouter from '@/router/index';                 // ルート情報取得

/**
 * 認証コンポーネント
 */
export default defineComponent({
    setup(props, ctx: SetupContext) {
        /**
         * 初期表示処理
         */
        created();
        async function created() {
            // titleIcon変更（初期化）
            ctx.root.$store.commit('setTitleIcon', '');

            // mainTitle変更（初期化）
            ctx.root.$store.commit('setMainTitle', '');

            // 認証情報取得
            checkSamlAuthentication();
        }

        const router = vueRouter;                           // ルータ

        /**
         * 認証情報取得
         */
        async function checkSamlAuthentication() {
            // 認証情報取得
            const response = await ctx.root.$store.dispatch('samlAuthentication/getAuthenticationUser');

            // HTTPステータスコードが200以外
            if (response.status !== HttpStatus.OK) {
                // エラー画面を表示する
                ctx.root.$store.commit('setErrorMessage', response.response.data.message);
                router.push('/error');
            }
            // HTTPステータスコードが200
            // root.state.authenticationUserに認証ユーザー情報を設定する
            ctx.root.$store.commit('setAuthenticationUser', response.data.loginUser, { root: true });

            router.push('/users/list');
        }
    }
});
